import { useState } from "react"
import { AUTH_EMAIL_APP_USER_REGISTRATION } from "../../utils/constants"
import QueueToFaxNumberAssociation from "../settingTabs/queueToFaxNumberAssociation"
import NetIdToFaxNumberAssociation from "../settingTabs/netIdToFaxNumberAssociation"
import RolePermissionsAssociation from "../settingTabs/rolePermissionsAssociation"
import QueuePermissionsAssociation from "../settingTabs/queuePermissionsAssociation"
import NetIdSharingPermissionsAssociation from "../settingTabs/netIdSharingPermissionsAssociation"
import MuscUsers from "../settingTabs/muscUsers"
import Phonebook from "../settingTabs/phonebook"
import UserSettings from "../settingTabs/userSettings"

import {
  Shuffle,
  IdCardLanyard,
  ShieldUser,
  Share2,
  FileLock2,
  Users,
  Phone,
  UserRoundCog,
} from "lucide-react"

const tabs = [
  {
    key: "queueToFaxNumberAssociation",
    label: "Queue ⇄ Fax Numbers",
    icon: (color) => <Shuffle size={18} fill={color} />,
  },
  {
    key: "netIdToFaxNumberAssociation",
    label: "NetID ⇄ Fax Numbers",
    icon: (color) => <IdCardLanyard size={18} fill={color} />,
  },
  {
    key: "rolePermissionsAssociation",
    label: "Role Permissions",
    icon: (color) => <FileLock2 size={18} fill={color} />,
  },
  {
    key: "queuePermissionsAssociation",
    label: "Queue ⇄ NetID",
    icon: (color) => <ShieldUser size={18} fill={color} />,
  },
  {
    key: "netIdSharingPermissionsAssociation",
    label: "NetId Sharing",
    icon: (color) => <Share2 size={18} fill={color} />,
  },
  {
    key: "muscUsers",
    label: "Musc Users",
    icon: (color) => <Users size={18} fill={color} />,
  },
  {
    key: "phonebook",
    label: "Phonebook",
    icon: (color) => <Phone size={18} fill={color} />,
  },
  {
    key: "userSettings",
    label: "User Settings",
    icon: (color) => <UserRoundCog size={18} fill={color} />,
  },
]

const Setting = ({ authUser, reloadQueues, queueLevelData }) => {
  let defaultTab = "queueToFaxNumberAssociation"
  if (authUser.loggedInUserType === "USER") {
    defaultTab = "queuePermissionsAssociation"
  }

  const [tab, setTab] = useState(defaultTab)
  const [loading, setLoading] = useState(false)

  let permittedTabs = tabs

  if (authUser.emailAddress !== AUTH_EMAIL_APP_USER_REGISTRATION) {
    permittedTabs = permittedTabs.filter((t) => t.key !== "appUserRegister")
  }

  // if (authUser.userRole !== "SUPER_ADMIN") {
  //   permittedTabs = permittedTabs.filter((t) => t.key === "history")
  // }

  if (authUser.loggedInUserType === "USER") {
    permittedTabs = permittedTabs.filter(
      (t) =>
        ![
          "queueToFaxNumberAssociation",
          "netIdToFaxNumberAssociation",
          "rolePermissionsAssociation",
          "muscUsers",
        ].includes(t.key)
    )
  }

  const fetchApps = async () => {
    setLoading(true)
    try {
      await new Promise((resolve) => setTimeout(resolve, 200))
      setLoading(false)
    } catch (error) {
      console.error("Failed to fetch", error)
      setLoading(false)
    }
  }

  // useEffect(() => {
  //   fetchApps()
  // }, [])

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "end",
        borderTop: "1px solid #ccc",
      }}
    >
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <div
          style={{
            width: "100%",
          }}
        >
          <div className="settings-tab-container">
            <div
              className="list-header-container"
              style={{
                width: "100%",
              }}
            >
              <div className="settings-tabs-container">
                <div className="settings-tabs-container-left">
                  {permittedTabs.map((t, i) => {
                    return (
                      <div
                        key={i}
                        onClick={() => setTab(t.key)}
                        className={`settings-tab-left-tabs ${
                          tab === t.key ? "selected" : ""
                        }`}
                      >
                        <div
                          style={{
                            margin: "10px",
                            display: "flex",
                            gap: "10px",
                          }}
                          key={t.key}
                        >
                          {t?.icon(tab === t.key ? "red" : "white")}
                          {t.label}
                        </div>
                        <div>
                          {tab === t.key && (
                            <button
                              title="Reload"
                              className="refresh-button"
                              onClick={() => {
                                fetchApps()
                              }}
                            >
                              ↻
                            </button>
                          )}
                        </div>
                      </div>
                    )
                  })}
                </div>

                <div className="settings-tabs-container-right">
                  {loading ? (
                    <div className="loading-container-fax-list"></div>
                  ) : (
                    <>
                      {{
                        queueToFaxNumberAssociation: (
                          <QueueToFaxNumberAssociation
                            reloadQueues={() => reloadQueues()}
                          />
                        ),
                        netIdToFaxNumberAssociation: (
                          <NetIdToFaxNumberAssociation
                            reloadQueues={() => reloadQueues()}
                          />
                        ),
                        rolePermissionsAssociation: (
                          <RolePermissionsAssociation />
                        ),
                        queuePermissionsAssociation: (
                          <QueuePermissionsAssociation authUser={authUser} />
                        ),
                        netIdSharingPermissionsAssociation: (
                          <NetIdSharingPermissionsAssociation
                            authUser={authUser}
                          />
                        ),
                        muscUsers: <MuscUsers />,
                        phonebook: (
                          <Phonebook queueLevelData={queueLevelData} />
                        ),
                        userSettings: <UserSettings />,
                      }[tab] || null}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Setting
